const created = new WeakMap<Blob | MediaSource, string>()
export function memoCreateObjectURL(file: Blob | MediaSource): string {
  if (!created.has(file)) {
    created.set(file, URL.createObjectURL(file))
  }

  return created.get(file)!
}
